module.exports = __webpack_public_path__ + "img/octave.b7807928.png";